import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AdminPanel from './pages/AdminPanel';
import EmployeePage from './pages/EmployeePage';
import Header from './components/Header';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header />
        <Routes>
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/card/:cardId" element={<EmployeePage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
